import { BrowserModule } from '@angular/platform-browser';
import { NgModule, HostBinding, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';


import { AppComponent } from './app.component';
import { SanitizeHtmlPipe } from './shared/pipes/sanitize-html.pipe';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { NavbarComponent } from './common/navbar/navbar.component';
import { HelpComponent } from './common/help/help.component';
import { LoginDialogComponent } from './modules/okta/login-dialog/login-dialog.component';

import { PublisherService } from './core/services/publisher.service';
import { StaticContentService } from './modules/static-content/static-content.service';
import { ContactUsService } from './modules/contact-us/contact-us.service';

import { MaterialModule } from './shared/modules/material.module';

import {OverlayContainer} from '@angular/cdk/overlay';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

import { RepchatAlertComponent } from './common/repchat-alert/repchat-alert.component';
import { Location, CurrencyPipe } from '@angular/common';
import { ChatService } from './modules/chat/chat.service';
import { ChatMessages } from './modules/chat/chat-messages';
import { OktaModule } from './modules/okta/okta.module';
import { BrowserTransferStateModule } from '@angular/platform-browser';
import { UserService } from './core/services/user.service';
import { OrderService } from './modules/order/order.service';
import { ClickStopPropogationDirective } from './shared/directives/click-stop-propogation.directive';
import { AddToCartComponent } from './modules/products/add-to-cart/add-to-cart.component';
import { InventoryAlertComponent } from './modules/products/inventory-alert/inventory-alert.component';
import { CoreModule } from './core/core.module';
import { UnderMaintenanceComponent } from './common/under-maintenance/under-maintenance.component';
import { StaticContentModule } from './modules/static-content/static.content.module';
import { FavouritesConfirmationComponent } from './modules/products/favorites/favourites-confirmation/favourites-confirmation.component';
import { CreateRenameFavoritesComponent } from './modules/products/favorites/create-rename-favorites/create-rename-favorites.component';
import { DeleteFavoriteProductComponent } from './modules/products/favorites/delete-favorite-product/delete-favorite-product.component';
import { DeleteWatchlistProductComponent } from './modules/products/watchlist/delete-watchlist-product/delete-watchlist-product.component';
import { AddWatchlistProductComponent } from './modules/products/watchlist/add-watchlist-product/add-watchlist-product.component';
import { PrivacyComponent } from './common/privacy/privacy.component';
import { LegalComponent } from './common/legal/legal.component';
import { HomeComponent } from './common/home/home.component';
import { PackageInsertComponent } from './common/package-insert/package-insert.component';
import { ProductsService } from './modules/products/products.service';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { CaseQtyAlertComponent } from './modules/products/inventory-alert/case-qty-alert/case-qty-alert.component';
import { SubscribeDialogComponent } from './modules/products/subscribe-dialog/subscribe-dialog.component';
import { AppCacheService } from './core/services/cache/app-cache.service';
import { CacheConstant } from './core/constants/app.constant';
import { AppConfigService } from './core/services/init/app-config.service';
import { SanitizerService } from './core/services/sanitizer.service';
import { ConfirmSubscriptionComponent } from './modules/products/confirm-subscription/confirm-subscription.component';
import { DirectiveModule } from './shared/modules/directive.module';
import { SkipSubscriptionComponent } from './modules/products/skip-subscription/skip-subscription.component';
import { UnsubscribeComponent } from './modules/products/unsubscribe/unsubscribe.component';
import { AdditionalConfirmSubscriptionComponent } from './modules/products/additional-confirm-subscription/additional-confirm-subscription.component';
import { CreditCardsService } from './modules/credit-cards/credit-cards.service';
import { ZoomImagesComponent } from './modules/products/zoom-images/zoom-images.component';
import { GenericPopupComponent } from '../app/modules/cms/generic-popup/generic-popup.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AddPopupComponent } from '../app/modules/cms/add-popup/add-popup.component';
import { ProductUtilService } from '../app/modules/products/product-util.service';
import { SalePopupComponent } from '../app/modules/cms/sale-popup/sale-popup.component';

import { PurchaseHistoryComponent } from './modules/products/purchase-history/purchase-history.component';
// import { BarcodeScanner } from 'nativescript-barcodescanner';
import { MajorHelpComponent } from './common/major-help/major-help.component';
import { MatIconModule } from '@angular/material/icon';
import { MajorAmazonComponent } from './common/amazon/amazon.component';
import { AboutUsComponent } from './modules/about-us/about-us.component';
import { MajorNewsComponent } from './modules/major-news/major-news.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AmazonVideoComponent } from './common/amazon/amazon_video/amazon_video.component';

@NgModule({
    declarations: [
        PurchaseHistoryComponent,
        AboutUsComponent,
        MajorNewsComponent,
        AppComponent,
        SanitizeHtmlPipe,
        HeaderComponent,
        FooterComponent,
        NavbarComponent,
        LoginDialogComponent,
        HelpComponent,
        RepchatAlertComponent,
        AddToCartComponent,
        InventoryAlertComponent,
        UnderMaintenanceComponent,
        ClickStopPropogationDirective,
        FavouritesConfirmationComponent,
        CreateRenameFavoritesComponent,
        DeleteFavoriteProductComponent,
        AddWatchlistProductComponent,
        DeleteWatchlistProductComponent,
        PrivacyComponent,
        LegalComponent,
        HomeComponent,
        PackageInsertComponent,
        CaseQtyAlertComponent,
        SubscribeDialogComponent,
        ConfirmSubscriptionComponent,
        SkipSubscriptionComponent,
        UnsubscribeComponent,
        AdditionalConfirmSubscriptionComponent,
        ZoomImagesComponent,
        GenericPopupComponent,
        AddPopupComponent,
        SalePopupComponent,
        MajorHelpComponent,
        MajorAmazonComponent,
        AmazonVideoComponent
    ],
    imports: [
        BrowserModule,
        ToastrModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        CoreModule.forRoot(),
        LoadingBarHttpClientModule,
        OktaModule,
        StaticContentModule,
        BrowserTransferStateModule,
        MatAutocompleteModule,
        DirectiveModule,
        MatIconModule,
        MatDialogModule
    ],
    providers: [
        PublisherService,
        StaticContentService,
        ContactUsService,
        UserService,
        OrderService,
        Location,
        ChatService,
        ChatMessages,
        CurrencyPipe,
        ProductsService,
        SanitizerService,
        CreditCardsService,
        ProductUtilService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  websiteName: string;
  @HostBinding('class') componentCssClass; 
  constructor(overlayContainer: OverlayContainer, private cache: AppCacheService, private appConfig: AppConfigService) {
    this.appConfig.isConfigLoaded.subscribe(res=>{
      if(res){
        this.websiteName = this.cache.get(CacheConstant.Env_Properties).theme;
        overlayContainer.getContainerElement().classList.add(this.websiteName);
        this.componentCssClass = this.websiteName;
      }
    })
  }
}
